import moment from 'moment';
import FormErrors from './FormErrors';

export default class FormValidations extends FormErrors {
  constructor(params = {}) {
    super();
    this.value = params.value;
    this.greaterThan = params.greaterThan;
    this.cpf = params.cpf;
    this.date = params.date;
    this.email = params.email;
    this.fullName = params.fullName;
    this.lowerThan = params.lowerThan;
    this.maxLength = params.maxLength;
    this.minLength = params.minLength;
    this.regex = params.regex;
    this.zipCode = params.zipCode;
    this.differentFrom = params.differentFrom;
    this.maxAge = params.maxAge;
    this.minAge = params.minAge;
  }

  validateMaxLength() {
    return !this.value || this.value.length <= this.maxLength;
  }

  validateMinLength() {
    return this.value && this.value.length >= this.minLength;
  }

  validateGreaterThan() {
    return this.value > this.greaterThan;
  }

  validateLowerThan() {
    return this.value < this.lowerThan;
  }

  validateZipCode() {
    return /\d{5}-?\d{3}/.test(this.value);
  }

  validateEmail() {
    return /^\w+([.-]?\w+)+@\w+([.:]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/.test(this.value);
  }

  validateDate() {
    const date = moment(this.value, 'DD/MM/YYYY');
    return date.isValid() && date <= moment();
  }

  validateMaxAge() {
    return moment(this.value, 'DD/MM/YYYY') >= moment().subtract(this.maxAge, 'years');
  }

  validateMinAge() {
    return moment(this.value, 'DD/MM/YYYY') <= moment().subtract(this.minAge, 'years');
  }

  validateCpf() {
    const cpf = this.clearValue();
    if (this.unallowedCpfs(cpf)) {
      return false;
    }
    return (
      this.validateCpfRule(cpf, 9, cpf.substring(9, 10), 11)
      && this.validateCpfRule(cpf, 10, cpf.substring(10, 11), 12)
    );
  }

  validateFullName() {
    return this.value.split(' ').length >= 2;
  }

  validateOnlyLettersAndSpaces() {
    return /^[A-Za-zÀ-ü\s']+$/u.test(this.value);
  }

  validateRegex() {
    return new RegExp(this.regex).test(this.value);
  }

  validateDifferentFrom() {
    return this.clearString(this.value) !== this.clearString(this.differentFrom.value);
  }

  clearValue() {
    return this.clearString(this.value);
  }

  clearString(string) {
    return (string || '').replace(/[. -]+/g, '');
  }

  validateCpfRule(cpf, endSumIndex, compareDigit, multiplyNumber) {
    let sum = 0;
    let rest = 0;

    for (let i = 1; i <= endSumIndex; i += 1) {
      sum += parseInt(cpf.substring(i - 1, i), 10) * (multiplyNumber - i);
    }

    rest = (sum * 10) % 11;

    if ((rest === 10) || (rest === 11)) { rest = 0; }
    if (rest.toString() !== compareDigit) { return false; }
    return true;
  }

  unallowedCpfs(cpf) {
    return (
      cpf.length !== 11
      || cpf === '01234567890'
      || cpf === '00000000000'
      || cpf === '11111111111'
      || cpf === '22222222222'
      || cpf === '33333333333'
      || cpf === '44444444444'
      || cpf === '55555555555'
      || cpf === '66666666666'
      || cpf === '77777777777'
      || cpf === '88888888888'
      || cpf === '99999999999'
    );
  }
}
